import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-globe-white',
  templateUrl: './icon-globe.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconGlobeWhiteComponent {}
